module.exports = __webpack_public_path__ + "img/专利证书06_环境监测商业智能算法软件v1.0.a49d11d3.png";